<div class="line-item-filter-container">
  <label *ngIf="label" class="filter-label">{{ label }}</label>
  <div class="line-item-filter display-flex">
    <va-cascader
      [options]="filteredOptions"
      [selectedValue]="selectedValue"
      [values]="resultedValues"
      [id]="liFilterId"
      [bottomBorderView]="bottomBorderView"
      [disabled]="disabled"
      [placeholder]="placeholder"
      [showLabel]="showLabel"
      [class]="cascaderClass"
      (onInputChange)="handleInputChange($event)"
      (valueChange)="handleValueChange($event)"
    ></va-cascader>
    <button
      *ngIf="showButton"
      nz-button
      class="lineitem-filter__edit-btn"
      (click)="handleEditButtonClick()"
      [disabled]="disabled"
    >
      Edit
    </button>
  </div>
</div>
